import PageTitle from "../../components/PageTitle";
import Tx from "../../components/Tx";
import IconBtn from "../../components/IconBtn";
import { useEffect, useState } from "react";
import UsersDialog from '../../components/dialogs/UsersDialog';
import { api } from "../../maps/data.js";
import Table from '../../components/Table';
import Icn from '../../components/Icn';

function UsersPage() {

    const [openUser, setOpenUser] = useState(false);
    const [users, s_users] = useState([]);

    const getUsers = async () => {
        const users_res = await api({ type: 'getUsers' });
        s_users(users_res.map(user => ({ ...user, role: <>{user.role.map(r => <Tx key={r}>{`user.add.${r}`}</Tx>)}</> })));
    }

    useEffect(() => {
        getUsers();
    }, []);

    return (
        <div style={{ height: '100%', overflowY: 'scroll', padding: 20 }}>
            <PageTitle>
                <Icn>user</Icn> <Tx>page.users.title</Tx>
                <IconBtn
                    style={{ position: 'absolute', right: 20 }}
                    onClick={() => setOpenUser({})}
                >
                    add
                </IconBtn>
            </PageTitle>
            <Table data={users} headers={[
                { label: <Tx>user.table.name</Tx>, field: 'name' },
                { label: <Tx>user.table.email</Tx>, field: 'email' },
                { label: <Tx>user.table.role</Tx>, field: 'role' }
            ]} />
            {openUser && (
                <UsersDialog
                    open={openUser}
                    onClose={() => { getUsers(); setOpenUser(false) }}
                />
            )}
        </div>
    )
}

export default UsersPage;